import { motion, type Transition } from "framer-motion";

import CloseIcon from "@/blueprint/components/NavPill/CloseIcon";
import MenuIcon from "@/blueprint/components/NavPill/MenuIcon";
import { NavMotion, seconds } from "@/blueprint/tokens/Motion";

/**
 * Pancake ↔ close, crossfaded in place. The menu button is one control that
 * changes its mark, not two controls that trade places, so the marks share a
 * grid cell and only opacity moves — on the same curve the desktop nav morphs
 * with, so the two surfaces read as one system.
 */
const NavMenuGlyph = ({
  open,
  reducedMotion,
}: {
  open: boolean;
  reducedMotion: boolean;
}) => {
  const transition: Transition = reducedMotion
    ? { duration: 0 }
    : {
        duration: seconds(NavMotion.glyphSwapMs),
        ease: [...NavMotion.contentIn.ease],
      };

  return (
    // Nudged 2px left of true centre: the marks read as hugging the margin
    // otherwise, while the 32px hit target stays put.
    <span className="grid -translate-x-0.5">
      <motion.span
        initial={false}
        animate={{ opacity: open ? 0 : 1 }}
        transition={transition}
        className="col-start-1 row-start-1 flex"
      >
        <MenuIcon />
      </motion.span>
      <motion.span
        initial={false}
        animate={{ opacity: open ? 1 : 0 }}
        transition={transition}
        className="col-start-1 row-start-1 flex"
      >
        <CloseIcon />
      </motion.span>
    </span>
  );
};

export default NavMenuGlyph;
